document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".custom-slideshow .slide");
  let currentIndex = 0;
  const slideDuration = 8000;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);

      // カウント表示更新
      const countEl = slide.querySelector(".slide-count");
      if (countEl) {
        countEl.textContent = `${index + 1} / ${slides.length}`;
      }

      // プログレスバー更新
      const bars = slide.querySelectorAll(".slide-bar");
      bars.forEach((bar, j) => {
        const fill = bar.querySelector(".fill");
        if (j === index) {
          bar.classList.add("active");
          fill.style.width = "0%";
          fill.style.backgroundColor = "#000";

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              fill.style.transition = `width ${slideDuration}ms linear`;
              fill.style.width = "100%";
            });
          });
        } else {
          bar.classList.remove("active");
          fill.style.transition = "none";
          fill.style.width = "0%";
          fill.style.backgroundColor = "#000";
        }
      });
    });
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  let timer = setInterval(nextSlide, slideDuration);

  // 手動ボタン
  document.querySelectorAll(".prev").forEach((btn) => {
    btn.addEventListener("click", () => {
      clearInterval(timer);
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(currentIndex);
      timer = setInterval(nextSlide, slideDuration);
    });
  });

  document.querySelectorAll(".next").forEach((btn) => {
    btn.addEventListener("click", () => {
      clearInterval(timer);
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
      timer = setInterval(nextSlide, slideDuration);
    });
  });

  showSlide(currentIndex);
});
